module.exports = __webpack_public_path__ + "img/homeR.a28622d9.png";